import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';
import Information from '../../component/Information';

const HwangInA = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "이용준 ♥ 황인아 결혼합니다.";
    const openDesc = "대전 루이비스컨벤션 그레이스홀 \n9월 27일 17시 50분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/251/thumb.jpg";

    const lng = 127.39804667277899;
    const lat = 36.42475192911509;
    
    const placeTelNum = "042-933-2500";

    const forParking = "호텔&컨벤션 주차장: 지상 주차\n아울렛 남문 주차장: 지상&지하 주차\n아울렛 북문 주차장: 지상&지하 주차\n\n외부 주차장: 대덕비즈센터\n(대전광역시 유성구 테크노 4로 17), 셔틀버스 상시 운행\n※ 웨딩홀 2시간 무료 + 아울렛 이용 시 3시간 추가\n\n\n▶남문 지상 주차시\n아울렛 정문 → 회전목마 뒤 후문 → 왼쪽 루이비스 위치\n남문 A4~A8 구역 주차시 - 아울렛 왼편 공원 직진 → 오른쪽 \n루이비스 위치\n\n▶남문 & 북문 지하 주차장 이용시\nn9 구역 호텔&컨벤션 입구 엘리베이터 이용 → 1층 루이비스\n\n▶북문 주차타워 이용시\n아울렛 후문 방향 직진 → 맞은편 루이비스 위치";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "박상윤 · 김미영의 장남"},
        {bride : "김명광 · 이명자의 장녀"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "최종국", isDeceased: false },
            mom: { name: "김복희", isDeceased: false },
            role: "차남",
        },
        bride: {
            dad: { name: "박민규", isDeceased: false },
            mom: { name: "안혜자", isDeceased: false },
            role: "장녀",
        }
    };

    const title = "우리 결혼합니다."

    const msg1 = "낙엽이 물드는 계절,\n저희가 한마음으로 사랑의 길을 걷기 시작합니다.";
    const msg2 = "두 사람의 인연을 축복해주시면\n그 마음을 소중히 간직하며\n아름다운 가정을 꾸려가겠습니다.";


    const groomAccountList = [
        {
            role: "신랑",
            name: "이용준",
            bank: "기업은행",
            accountNumber : "584-010092-01-012",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "이선명",
            bank: "기업은행",
            accountNumber : "584-003721-01-012",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "김미자",
            bank: "기업은행",
            accountNumber : "584-010826-01-021",
            isKakao : false
        }
    ]


    const brideAccountList = [
        {
            role: "신부",
            name: "황인아",
            bank: "국민은행",
            accountNumber : "538202-04-161190",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8RzMNcr"
        }
        ,{
            role: "신부 부",
            name: "황금강",
            bank: "하나은행",
            accountNumber : "679-910016-85808",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "주수정",
            bank: "농협은행",
            accountNumber : "352-1558-4944-43",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "박경민",
            call: "010-5323-6271"
        }
        // ,
        // {
        //     role: "신랑 부",
        //     name: "정창호",
        //     call: "010-3867-5127"
        // }
        ,{
            role: "신랑 모",
            name: "김미영",
            call: "010-2909-6271"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "김찬미",
            call: "010-5519-1501"
        }
        ,{
            role: "신부 부",
            name: "김명광",
            call: "010-7121-1506"
        }
        ,{
            role: "신부 모",
            name: "이명자",
            call: "010-4532-1501"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "지하철 앞",
            brideAnswer: "당연하지!"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "긴장 돼",
            brideAnswer: "두근두근"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "널 사랑해",
            brideAnswer: "사랑해❤️"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "한눈 안 팜",
            brideAnswer: "절대 지켜"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복하자",
            brideAnswer: "고마워"
        }
    ]

    const informationList =[
        {
            title : "피로연 안내",
            content : "날짜 7월 10일 오전 11시 ~ 오후 3시\n장소 충남 태안군 안면읍 백사장 1길 91\n진미각 중화요리"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall  conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>  */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper> */}
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forParking={forParking} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default HwangInA;